// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"802626cc","952":"e3afcb4e"}[chunkId] + ".chunk.js";
};